import { combineReducers } from 'redux';

// Reducers
import statisticReducer from './Statistic/store/statisticReducer';
import productOverviewReducer from './ProductOverview/store/productOverviewReducers';
import searchReducer from './Search/store/searchReducer';
import overviewReducer from './Overview/store/overviewReducer';
import reportReducer from './Report/store/reportReducer';
import userActivityReducer from './UserActivity/store/userActivityReducer';
import controlMachineReducer from './ControlMachine/store/controlMachineReducer';
import mobileEraseStationReducer from './MobileEraseStation/store/mobileEraseStationReducer';

export const subComponents = (translations) => [
    { name: translations["asset_overview"] || "Asset overview", path: '/asset-overview', permissions: ["all_assets_view"] },
    { name: translations["kpi_console"] || "KPI Console", path: '/kpi-overview', permissions: ["kpi_overview"]},
    { name: translations["overview"] || "System overview", path: '/system-overview', permissions: ['overview'] },
    { name: translations["admin_asset_view"] || "Admin asset view", path: '/admin-asset-view', permissions: ['all_admin_asset_view'] },
    { name: translations["remote_assets"] || "Remote access", path: '/remote-access', permissions: ['online_devices'] },
    { name: translations["upload_erasure_data"] || "Upload erasure data", path: '/upload-erasure-data', permissions: ['full_offline_erasure_session_upload_erasure_data'] },
    // { name: translations["kpi_overview"] || "KPI Overview", path: '/kpi-overview' },
    // { name: translations["printing_queue"] || "Printer Queue", path: '/printQueues', permissions: ['print_job_list'] },
    // { name: translations["report_generator"] || "Report generator", path: '/report-generator', permissions: ['report'] },
    // { name: translations["users_activities"] || "Users activities", path: '/user-activity', permissions: ['user_session_list'] },
    // { name: translations["control_machine"] || "Control machine", path: '/control-machine', permissions: ['control_machine'] },
    // { name: translations["mobile_erase_station"] || "Mobile station", path: '/mobile-erase-station', permissions: ['mobile_erase_station'] },
];

export const reducers = combineReducers({
    statistics: statisticReducer,
    productOverview: productOverviewReducer,
    searches: searchReducer,
    overview: overviewReducer,
    report: reportReducer,
    usersActivities: userActivityReducer,
    controlMachines: controlMachineReducer,
    mobileEraseStation: mobileEraseStationReducer,
});
